"use strict";

var _interopRequireDefault = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime@7.17.8@@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.function.name");

var _area = _interopRequireDefault(require("@/components/Address/area.json"));

var _index = require("@/api/user/index");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      areaList: _area.default,
      searchResult: [],
      AddressInfo: {
        id: '',
        name: '',
        tel: '',
        province: '',
        city: '',
        county: '',
        areaCode: '',
        addressDetail: '',
        postalCode: '',
        isDefault: true
      }
    };
  },
  created: function created() {
    this.fetchData();
  },
  mounted: function mounted() {},
  computed: {},
  methods: {
    onSave: function onSave(form) {
      var _this = this;

      var obj = this;
      (0, _index.userAddressEdit)(this.AddressInfo.id, {
        address: form.addressDetail,
        name: form.name,
        phone: form.phone,
        code: form.areaCode,
        is_default: form.isDefault ? 1 : 0
      }).then(function (res) {
        if (!res.code) {
          _this.$toast.success({
            message: '保存成功',
            duration: 500,
            onClose: function onClose() {
              obj.$router.push({
                name: 'userAddressIndex'
              });
            }
          });
        } else {
          _this.$toast(res.message);
        }
      }, function (error) {
        console.log(error);
      });
    },
    onDelete: function onDelete() {
      var _this2 = this;

      var obj = this;
      (0, _index.userAddressDel)(this.AddressInfo.id).then(function (res) {
        if (!res.code) {
          _this2.$toast.success({
            message: '删除成功',
            duration: 500,
            onClose: function onClose() {
              obj.$router.push({
                name: 'userAddressIndex'
              });
            }
          });
        }
      });
    },
    onChangeDetail: function onChangeDetail(val) {},
    fetchData: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(this.$route.params.id);
                _context.next = 3;
                return (0, _index.userAddressInfo)(this.$route.params.id).then(function (res) {
                  if (res.data) {
                    var data = res.data;
                    _this3.AddressInfo = {
                      id: data.id,
                      name: data.contact_name,
                      tel: data.contact_phone,
                      areaCode: data.district_code,
                      addressDetail: data.address,
                      isDefault: !!data.is_default
                    };
                  }
                }, function (error) {
                  console.log(error);
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchData() {
        return _fetchData.apply(this, arguments);
      }

      return fetchData;
    }(),
    goBack: function goBack() {
      this.$router.go(-1);
    }
  }
};
exports.default = _default;